import dayjs from "dayjs"
import utc from "dayjs/plugin/utc"
import { KM_PER_NM } from "@/config/defaults"

dayjs.extend(utc)

function finite(value) {
  const n = Number(value)
  return Number.isFinite(n) ? n : null
}

function format(value, digits) {
  return value == null ? "—" : value.toLocaleString("en-US", {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  })
}

// KPI tiles from the persisted route summary (totals as of the calculation;
// the live remaining values stay in the route table).
export default function routeKpis(summary) {
  // A zero-length total is a placeholder summary, not a measurement.
  const kmRaw = finite(summary?.total_distance_km)
  const km = kmRaw > 0 ? kmRaw : null
  const hours = finite(summary?.total_time_hour)
  const distanceNm = km == null ? null : km / KM_PER_NM
  const avgSpeedKn = km == null || !(hours > 0) ? null : km / hours / KM_PER_NM
  // Parse, don't slice: a non-Z offset must still display as UTC.
  const etaParsed = summary?.eta_utc ? dayjs.utc(summary.eta_utc) : null
  const eta = etaParsed?.isValid() ? etaParsed.format("YYYY-MM-DD HH:mm") : null
  const fuelTons = finite(summary?.total_consumption_tons)
  return [
    { key: "distance", label: "Distance", value: format(distanceNm, 0), unit: distanceNm == null ? null : "nm" },
    { key: "eta", label: "ETA (UTC)", value: eta ?? "—", unit: null },
    { key: "speed", label: "Ø Speed", value: format(avgSpeedKn, 1), unit: avgSpeedKn == null ? null : "kt" },
    { key: "fuel", label: "Fuel", value: format(fuelTons, 0), unit: fuelTons == null ? null : "t" },
  ]
}
